import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RESPONSE } from '../../../express.tokens';

import { BreadcrumbService } from '../../services/breadcrumb.service';
import { HeadService } from '../../services/head.service';
import { TitleService } from '../../services/title.service';
import { Response } from 'express';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [BreadCrumbComponent]
})
export class PageNotFoundComponent implements OnInit {
  private platformId = inject<Record<string, unknown>>(PLATFORM_ID);
  private response = inject<Response>(RESPONSE, { optional: true });
  private breadcrumbService = inject(BreadcrumbService);
  private headService = inject(HeadService);
  private titleService = inject(TitleService);


  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      this.response.status(404);
    }
    const title = 'Page Not Found';
    this.titleService.set(title);
    this.breadcrumbService.set(title);
    this.headService.setMetaDescription(title);
  }
}
